import * as Yup from "yup";

export const schema = {
  email: null,
  password: null,
};

export const validation = Yup.object().shape({
  email: Yup.string().required("กรุณาระบุอีเมล"),
  password: Yup.string().required("กรุณาระบุรหัสผ่าน"),
});
